export default {
	group: "inline",
	inline: true,
	draggable: true,
	attrs: {
		bind: { default: "" },
	},
};
